<template>
  <div>
    <!-- Drawer -->
    <v-navigation-drawer v-model="drawer" clipped app dark>
      <v-list>
        <v-list-item to="/home">
          <v-list-item-action>
            <v-icon>fa-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title small>
              Dashboard
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <template v-for="item in showMenus">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.icon"
            small
          >
            <template v-slot:activator>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:prepend>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="white">{{ item.icon }}</v-icon>
                </template>
                tooltip text
              </v-tooltip>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.link"
              style="padding-left: 25px"
            >
              <v-list-item-action>
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" :to="item.link">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- Top bar -->
    <v-app-bar clipped-left app>
      <v-toolbar-title>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </v-toolbar-title>
      <img
        src="https://app.applysys.com.br/img/applysys-logotipo.png"
        style="height:40px"
      />
      <div class="flex-grow-1"></div>
      <!-- <v-btn text to="/home">
        Dashboard
      </v-btn> -->
      <!-- <v-btn icon color="white">
        <v-icon>apps</v-icon>
      </v-btn> -->
      <v-btn icon color="white">
        <v-badge
          :content="this.messages"
          :value="this.messages"
          color="green"
          overlap
        >
          <v-icon v-bind:class="[this.messages > 0 ? 'bell' : '']"
            >notifications</v-icon
          >
        </v-badge>
      </v-btn>
      <v-btn icon color="white" @click="logout">
        <v-icon>{{ exitSvgPath }}</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-container class="fill-height" fluid>
        <router-view v-if="$route.name !== 'home'" />
        <v-row v-else-if="$route.name == 'home'">
          <v-col cols="4">
            <v-card class="px-10">
              <v-row>
                <v-col cols="5" align-self="center">
                  <v-row>
                    <v-icon class="info-icon icon-primary">fa-users</v-icon>
                  </v-row>
                </v-col>
                <v-col cols="7">
                  <v-row justify="end">
                    <v-card-text class="text-right pb-1">
                      Usuários
                    </v-card-text>
                    <v-card-title class="text-h2 pt-0">
                      {{ info.usuarios_ativos }}
                    </v-card-title>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card class="px-10">
              <v-row>
                <v-col cols="4" align-self="center">
                  <v-row>
                    <v-icon class="info-icon icon-warning">
                      fa-shopping-cart
                    </v-icon>
                  </v-row>
                </v-col>
                <v-col cols="8">
                  <v-row justify="end">
                    <v-card-text class="text-right pb-1">
                      Pedidos
                    </v-card-text>
                    <v-card-title class="text-h2 pt-0">
                      {{ info.pedidos_abertos }}
                    </v-card-title>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card class="px-10">
              <v-row>
                <v-col cols="5" align-self="center">
                  <v-row>
                    <v-icon class="info-icon icon-info">
                      fa-money-bill-wave
                    </v-icon>
                  </v-row>
                </v-col>
                <v-col cols="7">
                  <v-row justify="end">
                    <v-card-text class="text-right pb-1">
                      Vendas
                    </v-card-text>
                    <v-card-title class="text-h2 pt-0">
                      {{ info.vendas }}
                    </v-card-title>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12">
            <OrdersListTable
              title="Novos Pedidos"
              :orders="newOrders"
              :loading="$apollo.loading"
            ></OrdersListTable>
            <OrdersListTable
              class="mt-8"
              title="Visualizados"
              :orders="confirmedOrders"
              :loading="$apollo.loading"
            ></OrdersListTable>
            <OrdersListTable
              class="mt-8"
              title="Entregando"
              :orders="deliveringOrders"
              :loading="$apollo.loading"
            ></OrdersListTable>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <audio
      src="http://soundbible.com/mp3/analog-watch-alarm_daniel-simion.mp3"
      muted="muted"
      id="audioplayer"
      preload="auto"
      hidden
    >
      <p>Seu nevegador não suporta o elemento audio.</p>
    </audio>
  </div>
</template>

<script>
import gql from "graphql-tag";
import VueJwtDecode from "vue-jwt-decode";
import { GetOrders, GetOrdersSubscription } from "../graphql/orders.graphql";

//Components
import OrdersListTable from "./orders/Table.vue";

import { Action } from "../store/auth/types";

import { mdiExitToApp } from "@mdi/js";
export default {
  name: "home",
  components: {
    OrdersListTable
  },
  data: () => ({
    drawer: null,
    dialogOrder: false,
    editedItem: [],
    messages: null,
    newOrders: null,
    confirmedOrders: null,
    deliveringOrders: null,
    id_drugstore: null,
    show: false,
    drugstoreIds: null,
    headers: [
      { text: "Farmácia", value: "drugstore.name" },
      { text: "Usuario", value: "user.name" },
      { text: "CEP", value: "address.cep" },
      { text: "Logradouro", value: "address.street" },
      { text: "Número", value: "address.number" },
      { text: "Complemento", value: "address.complemento" },
      { text: "Status", value: "order_status.status" },
      { text: "Data da entrega", value: "dt_delivered" },
      { text: "Pagamento", value: "payment_type.type" },
      { text: "Total", value: "total" },
      { text: "Troco", value: "change" },
      { text: "Ações", value: "action", sortable: false }
    ],
    menu: [
      {
        icon: "fa-shopping-cart",
        text: "Pedidos",
        model: false,
        admin: false,
        children: [
          {
            icon: "fa-list",
            text: "Lista",
            link: "/orders/list/todos",
            admin: false
          },
          {
            icon: "fa-ellipsis-h",
            text: "Em andamento",
            link: "/orders/list/andamentos",
            admin: false
          },
          {
            icon: "fa-check-double",
            text: "Entregues",
            link: "/orders/list/entregues",
            admin: false
          },
          {
            icon: "fa-ban",
            text: "Cancelados",
            link: "/orders/list/cancelados",
            admin: false
          }
        ]
      },
      {
        icon: "local_pharmacy",
        "icon-alt": "local_pharmacy",
        text: "Produtos",
        model: false,
        admin: false,
        children: [
          {
            icon: "fa-list",
            text: "Todos",
            link: "/products/list/todos",
            admin: false
          },
          {
            icon: "fa-check",
            text: "Ativos",
            link: "/products/list/ativos",
            admin: false
          },
          {
            icon: "fa-hand-holding-usd",
            text: "Em ofertas",
            link: "/products/list/promocao",
            admin: false
          },
          {
            icon: "fa-search-dollar",
            text: "Preços",
            link: "/products/prices/list",
            admin: true
          },
          {
            icon: "fa-sort",
            text: "Ordenar",
            link: "/products/order",
            admin: true
          }
        ]
      },
      {
        icon: "fa-cogs",
        text: "Administração",
        model: false,
        admin: true,
        children: [
          {
            icon: "fa-list-alt",
            text: "Categorias",
            model: false,
            link: "/categories/list",
            admin: false
          },
          {
            icon: "fa-clinic-medical",
            text: "Farmácias",
            model: false,
            link: "/drugstores/list",
            admin: false
          },
          {
            icon: "fa-desktop",
            text: "Banner",
            model: false,
            link: "/banners/list",
            admin: false
          },
          {
            icon: "fa-motorcycle",
            text: "Entregadores",
            link: "/users/list/3",
            admin: false
          },
          {
            icon: "fa-user",
            text: "Usuários",
            link: "/users/list/0",
            admin: false
          },
          {
            icon: "fa-file-import",
            text: "Importar",
            link: "/import/price",
            admin: false
          },
          {
            icon: "fa-map",
            text: "Mapas",
            link: "/mapa",
            admin: false
          },
          {
            icon: "fa-store",
            text: "Vitrine",
            link: "/showcase",
            admin: false
          },
          {
            icon: "fa-robot",
            text: "Bot",
            link: "/bot",
            admin: false
          }
        ]
      }
    ],
    info: {
      usuarios_ativos: 0,
      pedidos_abertos: 0
    },
    exitSvgPath: mdiExitToApp,
    initialDark: false
  }),
  apollo: {
    $subscribe: {
      orders: {
        query: GetOrdersSubscription,
        result({ data }) {          
          this.newOrders = data.orders.filter((order)=>order.id_status == 1);
          this.confirmedOrders =  data.orders.filter((order)=>order.id_status == 2);
          this.deliveringOrders =  data.orders.filter((order)=>order.id_status == 4);
          this.messages = this.newOrders.length;
        }
      },
    }
  },
  computed: {
    showMenus: function(user_role) {
      let m = [];

      if (localStorage.token) {
        user_role = VueJwtDecode.decode(localStorage.token);
      }

      m = this.menu.filter(function(u) {
        return (u.admin && user_role && user_role.role == "admin") || !u.admin;
      });

      for (var i = 0; i < m.length; i++) {
        if (m[i].children) {
          for (var y = 0; y < m[i].children.length; y++) {
            if (
              m[i].children[y].admin &&
              user_role &&
              user_role.role !== "admin"
            ) {
              m[i].children.splice(y, 1);
            }
          }
        }
      }
      return m;
    },
    getMessages: function() {
      return this.$store.state.messages.length;
    }
  },
  methods: {
    close() {
      this.dialogOrder = false;
    },

    editOrder(item) {
      this.dialogOrder = true;
      this.editedItem = item;
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day1] = date.split("-");
      const [day, x] = day1.split("T");
      // eslint-disable-next-line no-unused-vars
      const [hour, x1] = x.split(".");

      return `${day}/${month}/${year} ${hour}`;
    },

    total(item) {
      if (!item) return 0;

      var total = 0;
      item.carts.forEach(element => {
        total += element.total;
      });

      return total.toFixed(2);
    },

    troco(item) {
      if (!item) return 0;

      var troco = 0;
      var total = 0;
      item.carts.forEach(element => {
        total += element.total;
      });

      troco = item.change > 0 && total > 0 ? item.change - total : 0;

      return troco.toFixed(2);
    },

    logout() {
      this.$store
        .dispatch(`${Action.LOGOUT}`)
        .then(() => this.$router.push({ path: "/" }));
    }
  },
  created() {
    const user = JSON.parse(localStorage.user);
    this.drugstoreIds =
      user.role.id !== 1
        ? user.users_drugstores.map(drugstore => drugstore.id_drugstore)
        : null;
    this.$vuetify.theme.dark = true;
    this.$apollo
      .query({
        query: gql`
          query MyQuery($drugstore_ids: Int_comparison_exp = {}) {
            users_aggregate(
              where: { id_role: { _eq: 4 }, enabled: { _eq: true } }
            ) {
              aggregate {
                count(columns: id)
              }
            }
            pedidos_abertos: orders(
              where: {
                order_status: { id: { _eq: 1 } }
                id_drugstore: $drugstore_ids
              }
            ) {
              id
            }
            vendas: orders_aggregate(
              where: { id_status: { _eq: 6 }, id_drugstore: $drugstore_ids }
            ) {
              aggregate {
                count(columns: id)
              }
            }
          }
        `,
        variables: {
          drugstore_ids: this.drugstoreIds ? { _in: this.drugstoreIds } : {}
        }
      })
      .then(data => {
        this.info.usuarios_ativos = data.data.users_aggregate.aggregate.count;
        if (data.data.pedidos_abertos) {
          this.info.pedidos_abertos = data.data.pedidos_abertos.length;
        }
        this.info.vendas = data.data.vendas.aggregate.count;
      });
  },
  updated() {
    // window.addEventListener("load", function(event) {
    //   var sound = document.getElementById("audio");
    //   sound.currentTime = 0;
    //   sound.play();
    // });
  },
  watch: {
    messages: function(newVal) {
      const audio = document.getElementById("audioplayer");
      audio.loop = true;
      if (newVal > 0) {
        audio.play();
      } else {
        audio.pause();
      }
    }
  }
};
</script>

<style>
.bell {
  -webkit-animation: ring 4s 0.7s ease-in-out infinite;
  -webkit-transform-origin: 50% 4px;
  -moz-animation: ring 4s 0.7s ease-in-out infinite;
  -moz-transform-origin: 50% 4px;
  animation: ring 4s 0.7s ease-in-out infinite;
  transform-origin: 50% 4px;
}

.info-icon {
  height: 50px;
  width: 50px;
  border-radius: 50%;
}

.v-list .v-icon {
  font-size: 14px !important;
}

.info-icon.icon-info {
  background: #1d8cf8;
  background-image: -webkit-gradient(
    linear,
    right top,
    left bottom,
    from(#1d8cf8),
    color-stop(#3358f4),
    to(#1d8cf8)
  );
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8);
  background-size: 210% 210%;
  background-position: 100% 0;
}

.info-icon.icon-warning {
  background: #ff8d72;
  background-image: -webkit-gradient(
    linear,
    right top,
    left bottom,
    from(#ff8d72),
    color-stop(#ff6491),
    to(#ff8d72)
  );
  background-image: linear-gradient(to bottom left, #ff8d72, #ff6491, #ff8d72);
  background-size: 210% 210%;
  background-position: 100% 0;
}

.info-icon.icon-primary {
  background: #e14eca;
  background-image: -webkit-gradient(
    linear,
    right top,
    left bottom,
    from(#e14eca),
    color-stop(#ba54f5),
    to(#e14eca)
  );
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca);
  background-size: 210% 210%;
  background-position: 100% 0;
}

@-webkit-keyframes ring {
  0% {
    -webkit-transform: rotateZ(0);
  }
  1% {
    -webkit-transform: rotateZ(30deg);
  }
  3% {
    -webkit-transform: rotateZ(-28deg);
  }
  5% {
    -webkit-transform: rotateZ(34deg);
  }
  7% {
    -webkit-transform: rotateZ(-32deg);
  }
  9% {
    -webkit-transform: rotateZ(30deg);
  }
  11% {
    -webkit-transform: rotateZ(-28deg);
  }
  13% {
    -webkit-transform: rotateZ(26deg);
  }
  15% {
    -webkit-transform: rotateZ(-24deg);
  }
  17% {
    -webkit-transform: rotateZ(22deg);
  }
  19% {
    -webkit-transform: rotateZ(-20deg);
  }
  21% {
    -webkit-transform: rotateZ(18deg);
  }
  23% {
    -webkit-transform: rotateZ(-16deg);
  }
  25% {
    -webkit-transform: rotateZ(14deg);
  }
  27% {
    -webkit-transform: rotateZ(-12deg);
  }
  29% {
    -webkit-transform: rotateZ(10deg);
  }
  31% {
    -webkit-transform: rotateZ(-8deg);
  }
  33% {
    -webkit-transform: rotateZ(6deg);
  }
  35% {
    -webkit-transform: rotateZ(-4deg);
  }
  37% {
    -webkit-transform: rotateZ(2deg);
  }
  39% {
    -webkit-transform: rotateZ(-1deg);
  }
  41% {
    -webkit-transform: rotateZ(1deg);
  }

  43% {
    -webkit-transform: rotateZ(0);
  }
  100% {
    -webkit-transform: rotateZ(0);
  }
}

@-moz-keyframes ring {
  0% {
    -moz-transform: rotate(0);
  }
  1% {
    -moz-transform: rotate(30deg);
  }
  3% {
    -moz-transform: rotate(-28deg);
  }
  5% {
    -moz-transform: rotate(34deg);
  }
  7% {
    -moz-transform: rotate(-32deg);
  }
  9% {
    -moz-transform: rotate(30deg);
  }
  11% {
    -moz-transform: rotate(-28deg);
  }
  13% {
    -moz-transform: rotate(26deg);
  }
  15% {
    -moz-transform: rotate(-24deg);
  }
  17% {
    -moz-transform: rotate(22deg);
  }
  19% {
    -moz-transform: rotate(-20deg);
  }
  21% {
    -moz-transform: rotate(18deg);
  }
  23% {
    -moz-transform: rotate(-16deg);
  }
  25% {
    -moz-transform: rotate(14deg);
  }
  27% {
    -moz-transform: rotate(-12deg);
  }
  29% {
    -moz-transform: rotate(10deg);
  }
  31% {
    -moz-transform: rotate(-8deg);
  }
  33% {
    -moz-transform: rotate(6deg);
  }
  35% {
    -moz-transform: rotate(-4deg);
  }
  37% {
    -moz-transform: rotate(2deg);
  }
  39% {
    -moz-transform: rotate(-1deg);
  }
  41% {
    -moz-transform: rotate(1deg);
  }

  43% {
    -moz-transform: rotate(0);
  }
  100% {
    -moz-transform: rotate(0);
  }
}

@keyframes ring {
  0% {
    transform: rotate(0);
  }
  1% {
    transform: rotate(30deg);
  }
  3% {
    transform: rotate(-28deg);
  }
  5% {
    transform: rotate(34deg);
  }
  7% {
    transform: rotate(-32deg);
  }
  9% {
    transform: rotate(30deg);
  }
  11% {
    transform: rotate(-28deg);
  }
  13% {
    transform: rotate(26deg);
  }
  15% {
    transform: rotate(-24deg);
  }
  17% {
    transform: rotate(22deg);
  }
  19% {
    transform: rotate(-20deg);
  }
  21% {
    transform: rotate(18deg);
  }
  23% {
    transform: rotate(-16deg);
  }
  25% {
    transform: rotate(14deg);
  }
  27% {
    transform: rotate(-12deg);
  }
  29% {
    transform: rotate(10deg);
  }
  31% {
    transform: rotate(-8deg);
  }
  33% {
    transform: rotate(6deg);
  }
  35% {
    transform: rotate(-4deg);
  }
  37% {
    transform: rotate(2deg);
  }
  39% {
    transform: rotate(-1deg);
  }
  41% {
    transform: rotate(1deg);
  }

  43% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(0);
  }
}
</style>
